/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-mpv-665947a9--sprite",
  "use": "car-mpv-665947a9--sprite-usage",
  "viewBox": "0 0 46 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 46 21\" id=\"car-mpv-665947a9--sprite\"><path d=\"M1 7v8a1 1 0 001 1h3M1 7h11M1 7l3.21-5.504A1 1 0 015.075 1H13m0 0l-1 6m1-6h11.5M39 7h1a5 5 0 015 5v3a1 1 0 01-1 1h-3m-2-9l-7.733-5.8a1 1 0 00-.6-.2H24.5M39 7H24.5M41 16a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H13m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m7-9h12.5m0 0V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M24.5 7H12l3 6h9.5m0-6H39l-5 6h-9.5m0-6v6m-24-3H3v2H1m44-2h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
